// src/data/dummyGolfCourses.js

// ferry_route_ids: IDs from FERRIESCourses that serve each course's destination.
// Harbourfront courses (Batam Hills, Southlinks, Indah Puri, Padang Golf): f1, f3, f7
// Tanah Merah courses (Palm Springs, BICC): f2, f4

export const dummyGolfCourses = [
  {
    id: "1",
    name: "Southlinks Golf & Country Club",
    city: "Batam",
    country: "Indonesia",
    rating: 4.2,
    price: 80,
    image: "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1200&q=80",
    images: [
      "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=1200&q=80",
      "https://images.unsplash.com/photo-1592919505780-303950717480?w=1200&q=80",
      "https://images.unsplash.com/photo-1510124351-580e89f3e3c1?w=1200&q=80",
    ],
    description:
      "Set within 213 hectares of lush rolling countryside in central Batam, Southlinks Golf & Country Club offers an 18-hole, Par 72 championship course designed by Japanese architect Hisamitsu Ohnishi and opened in 1996. The out-and-back routing takes golfers across elevated ground adjacent to the Sei Ladi Reservoir, providing peaceful tropical scenery throughout the round. The course is suitable for all skill levels, with a layout that rewards both accuracy and distance. Beyond golf, Southlinks offers world-class country club facilities including accommodation, a swimming pool, tennis courts, and a driving range.",
    amenities: ["Accommodation", "Swimming Pool", "Tennis Courts", "Driving Range", "Restaurant"],
    available_times: ["07:00", "07:30", "08:00", "08:30", "09:00", "09:30", "10:00"],
    fees_included: ["Green Fee", "Buggy", "Caddie"],
    ferry_route_ids: ["f1", "f3", "f7"],
    // Curated partner hotels for this course (Sekupang, Harbourbay, Batam Centre) — index 0 is recommended.
    accommodation_hotel_ids: ["h_sl_sekupang", "h_sl_harbourbay", "h_sl_batamcentre"],
  },
  {
    id: "2",
    name: "Batam Island Country Club",
    city: "Batam",
    country: "Indonesia",
    rating: 4.3,
    price: 100,
    image: "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=1200&q=80",
    images: [
      "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1200&q=80",
      "https://images.unsplash.com/photo-1611374243147-44a702c2d44c?w=1200&q=80",
      "https://images.unsplash.com/photo-1510124351-580e89f3e3c1?w=1200&q=80",
    ],
    description:
      "Batam Island Country Club (formerly Tering Bay Golf & Country Club) is a breathtaking 18-hole, Par 72 championship course designed by golf legend Greg Norman and opened in 1995. Stretching up to 6,405 metres, the course winds through rolling hills, pristine lakes, and lush tropical jungle, offering a visually stunning and strategically demanding round of golf. A fair mix of long and short holes ensures it caters to all handicaps. The club boasts excellent facilities including a restaurant, ballroom, pro shop with equipment rentals, driving range, locker rooms, and a golfers' lounge.",
    amenities: ["Restaurant", "Ballroom", "Pro Shop", "Driving Range", "Locker Rooms", "Golfers Lounge"],
    available_times: ["06:30", "07:00", "07:30", "08:00", "09:00", "10:00", "11:00"],
    fees_included: ["Green Fee", "Buggy", "Caddie", "Insurance"],
    ferry_route_ids: ["f2", "f4"],
    // Shared Nongsa-area partner hotels for Palm Springs / BICC — index 0 is recommended.
    accommodation_hotel_ids: ["h_ng_batamview", "h_ng_turibeach", "h_ng_marina", "h_ng_nuvasa"],
  },
  {
    id: "3",
    name: "Palm Springs Golf & Beach Resort",
    city: "Batam",
    country: "Indonesia",
    rating: 4.5,
    price: 90,
    image: "https://images.unsplash.com/photo-1592919505780-303950717480?w=1200&q=80",
    images: [
      "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1200&q=80",
      "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=1200&q=80",
      "https://images.unsplash.com/photo-1611374243147-44a702c2d44c?w=1200&q=80",
    ],
    description:
      "Palm Springs Golf & Beach Resort is a stunning 18-hole, Par 72 seaside course nestled along the coast of Batam. Designed with panoramic ocean views and cooling sea breezes, the course offers a unique blend of challenge and relaxation. The layout features wide fairways transitioning into tight, tree-lined finishing holes. The resort also offers beachfront accommodation, spa facilities, and a rooftop restaurant with views across the Singapore Strait.",
    amenities: ["Beach Access", "Spa", "Rooftop Restaurant", "Accommodation", "Pro Shop"],
    available_times: ["06:00", "06:30", "07:00", "08:00", "09:30", "11:00"],
    fees_included: ["Green Fee", "Buggy"],
    ferry_route_ids: ["f2", "f4"],
    // Shared Nongsa-area partner hotels for Palm Springs / BICC — index 0 is recommended.
    accommodation_hotel_ids: ["h_ng_batamview", "h_ng_turibeach", "h_ng_marina", "h_ng_nuvasa"],
  },
  {
    id: "4",
    name: "Ria Bintan Golf Club – Forest Course",
    city: "Bintan",
    country: "Indonesia",
    rating: 4.6,
    price: 120,
    image: "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1200&q=80",
    images: [
      "https://images.unsplash.com/photo-1592919505780-303950717480?w=1200&q=80",
      "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1200&q=80",
      "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=1200&q=80",
    ],
    description:
      "Ria Bintan Golf Club's Forest Course is an 18-hole, Par 71 masterpiece carved through dense tropical rainforest. Designed by Gary Player and opened in 1997, the course demands strategic shot-making as players navigate narrow jungle corridors and well-placed water hazards. The lush, shaded fairways provide a cool and immersive playing experience unlike any other in the region. Facilities include a fully equipped clubhouse, caddy services, electric cart rentals, and a pro shop stocked with premium equipment.",
    amenities: ["Clubhouse", "Caddy Service", "Electric Carts", "Pro Shop"],
    available_times: ["07:00", "07:30", "08:30", "09:00", "10:00"],
    fees_included: ["Green Fee", "Caddie", "Buggy", "Range Balls"],
    ferry_route_ids: null,
  },
  {
    id: "5",
    name: "Damai Indah Golf – BSD Course",
    city: "Tangerang",
    country: "Indonesia",
    rating: 4.1,
    price: 70,
    image: "https://images.unsplash.com/photo-1611374243147-44a702c2d44c?w=1200&q=80",
    images: [
      "https://images.unsplash.com/photo-1510124351-580e89f3e3c1?w=1200&q=80",
      "https://images.unsplash.com/photo-1592919505780-303950717480?w=1200&q=80",
      "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1200&q=80",
    ],
    description:
      "Damai Indah Golf's BSD Course is a well-regarded 18-hole, Par 72 championship layout set within the satellite city of BSD in Tangerang. Designed to international standards, the course features undulating terrain, strategic bunkering, and several challenging water holes. The club is popular among Jakarta's business community and regularly hosts corporate tournaments. Amenities include a modern clubhouse, restaurant, function rooms, and practice facilities.",
    amenities: ["Modern Clubhouse", "Restaurant", "Function Rooms", "Practice Facilities"],
    available_times: ["06:30", "07:30", "08:00", "09:00", "10:30", "11:30"],
    fees_included: ["Green Fee", "Buggy"],
    ferry_route_ids: null,
  },
  {
    id: "6",
    name: "Indah Puri Golf Club",
    city: "Batam",
    country: "Indonesia",
    rating: 4.1,
    price: 70,
    image: "https://batamhillsgolf.com/wp-content/uploads/2017/08/Gedung-BHGR.png",
    images: [
      "https://images.unsplash.com/photo-1510124351-580e89f3e3c1?w=1200&q=80",
      "https://images.unsplash.com/photo-1592919505780-303950717480?w=1200&q=80",
      "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1200&q=80",
    ],
    description:
      "Indah Puri Golf Club is a scenic 18-hole, Par 72 course tucked into the hills of western Batam. The course features tree-lined fairways, natural water features, and a variety of challenging holes catering to all skill levels. The club is well-known for its immaculate greens and warm hospitality. Facilities include a modern clubhouse, restaurant, function rooms, and a practice range.",
    amenities: ["Modern Clubhouse", "Restaurant", "Function Rooms", "Practice Facilities"],
    available_times: ["06:30", "07:30", "08:00", "09:00", "10:30", "11:30"],
    fees_included: ["Green Fee", "Buggy"],
    ferry_route_ids: ["f1", "f3", "f7"],
    // Curated partner hotels for this course (Sekupang, Harbourbay, Batam Centre) — index 0 is recommended.
    accommodation_hotel_ids: ["h_ip_sekupang", "h_ip_harbourbay", "h_ip_batamcentre"],
  },
  {
    id: "7",
    name: "Batam Hills Golf Resort",
    city: "Batam",
    country: "Indonesia",
    rating: 4.1,
    price: 70,
    image: "https://www.iacworldwide.com/app/uploads/2019/02/sliderv1.png",
    images: [
      "https://images.unsplash.com/photo-1510124351-580e89f3e3c1?w=1200&q=80",
      "https://images.unsplash.com/photo-1592919505780-303950717480?w=1200&q=80",
      "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1200&q=80",
    ],
    description:
      "Batam Hills Golf Resort is a well-maintained 18-hole, Par 72 course set across rolling hills in northern Batam. The layout offers a diverse mix of open and tree-framed holes with sweeping views of the surrounding landscape. The resort is ideal for day-trip golfers from Singapore, with convenient ferry access from HarbourFront. Facilities include a driving range, restaurant, pro shop, and on-site accommodation.",
    amenities: ["Modern Clubhouse", "Restaurant", "Driving Range", "Pro Shop", "Accommodation"],
    available_times: ["06:30", "07:30", "08:00", "09:00", "10:30", "11:30"],
    fees_included: ["Green Fee", "Buggy"],
    ferry_route_ids: ["f1", "f3", "f7"],
    // Curated partner hotels for this course (Sekupang, Harbourbay, Batam Centre) — index 0 is recommended.
    accommodation_hotel_ids: ["h_bh_sekupang", "h_bh_harbourbay", "h_bh_batamcentre"],
  },
  {
    id: "8",
    name: "Padang Golf Sukajadi",
    city: "Batam",
    country: "Indonesia",
    rating: 4.0,
    price: 65,
    image: "https://images.unsplash.com/photo-1510124351-580e89f3e3c1?w=1200&q=80",
    images: [
      "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1200&q=80",
      "https://images.unsplash.com/photo-1592919505780-303950717480?w=1200&q=80",
      "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=1200&q=80",
    ],
    description:
      "Padang Golf Sukajadi is one of Batam's most accessible public golf facilities, offering a well-groomed 18-hole course in the heart of the Sukajadi area. The layout is friendly for all handicaps with wide fairways and generous greens. Its central location makes it a convenient choice for golfers arriving via HarbourFront ferry terminals. The club features a comfortable clubhouse, pro shop, and practice nets.",
    amenities: ["Clubhouse", "Pro Shop", "Practice Nets", "Restaurant"],
    available_times: ["07:00", "07:30", "08:00", "09:00", "10:00", "11:00"],
    fees_included: ["Green Fee", "Buggy"],
    ferry_route_ids: ["f1", "f3", "f7"],
    // Curated partner hotels for this course (Sekupang, Harbourbay, Batam Centre) — index 0 is recommended.
    accommodation_hotel_ids: ["h_pg_sekupang", "h_pg_harbourbay", "h_pg_batamcentre"],
  },
];

// data/ferryDummyData.js

export const FERRIESCourses = [
  {
    id: "f1",
    origin_port: "HarbourFront Centre, Singapore",
    destination_port: "Batam Centre Ferry Terminal, Batam",
    operator: "Batam Fast Ferry",
    duration_minutes: 45,
    base_price_per_passenger: 32,
    image: "https://horizonfastferry.com.sg/blog/wp-content/uploads/2024/01/111.jpg",
    description: "The most popular Singapore–Batam route, operated by Batam Fast with modern high-speed vessels and frequent departures throughout the day.",
    available_times: ["08:00", "09:30", "11:00", "13:00", "15:00", "17:00", "19:00"],
    return_available_times: ["09:00", "10:30", "12:00", "14:00", "16:00", "18:00", "20:00"],
    amenities: ["Air Conditioning", "Snack Bar", "Life Jackets", "Luggage Storage", "USB Charging"],
    fees_included: ["Terminal Fee", "Immigration Levy", "Port Tax"],
    vessel_type: "High-Speed",
    supports_round_trip: true,
    one_way_available: true,
  },
  {
    id: "f2",
    origin_port: "Tanah Merah Ferry Terminal, Singapore",
    destination_port: "Nongsapura Ferry Terminal, Batam",
    operator: "Batam Fast Ferry",
    duration_minutes: 55,
    base_price_per_passenger: 28,
    image: "https://horizonfastferry.com.sg/blog/wp-content/uploads/2024/01/111.jpg",
    description: "A reliable service from Tanah Merah to Nongsa — ideal for golfers heading to Palm Springs and BICC. Comfortable seating with panoramic sea views.",
    available_times: ["07:30", "10:00", "13:30", "16:30"],
    return_available_times: ["09:00", "12:00", "15:30", "18:30"],
    amenities: ["Air Conditioning", "Reclining Seats", "Life Jackets", "Luggage Storage"],
    fees_included: ["Terminal Fee", "Port Tax"],
    vessel_type: "High-Speed",
    supports_round_trip: true,
    one_way_available: true,
  },
  {
    id: "f3",
    origin_port: "HarbourFront Centre, Singapore",
    destination_port: "Sekupang Ferry Terminal, Batam",
    operator: "Batam Fast Ferry",
    duration_minutes: 50,
    base_price_per_passenger: 30,
    image: "https://horizonfastferry.com.sg/blog/wp-content/uploads/2024/01/111.jpg",
    description: "Batam Fast's direct service to Sekupang Terminal — the gateway for Batam Hills, Southlinks, and Indah Puri courses. Modern vessels with frequent sailings.",
    available_times: ["08:30", "11:00", "14:00", "17:30"],
    return_available_times: ["10:00", "13:00", "16:00", "19:30"],
    amenities: ["Air Conditioning", "Snack Bar", "Business Class Seats", "Luggage Storage", "Wi-Fi"],
    fees_included: ["Terminal Fee", "Immigration Levy", "Port Tax", "Travel Insurance"],
    vessel_type: "High-Speed",
    supports_round_trip: true,
    one_way_available: true,
  },
  {
    id: "f4",
    origin_port: "Tanah Merah Ferry Terminal, Singapore",
    destination_port: "Batam Centre Ferry Terminal, Batam",
    operator: "Majestic Fast Ferry",
    duration_minutes: 60,
    base_price_per_passenger: 25,
    image: "https://www.batamfast.com/Content/Images/vessel/aseanraider2-22072020b.jpg",
    description: "An economical one-way option from Tanah Merah to Batam Centre. Basic but reliable — good choice for budget-conscious day trippers.",
    available_times: ["09:00", "14:00", "18:00"],
    return_available_times: [],
    amenities: ["Air Conditioning", "Life Jackets", "Luggage Storage"],
    fees_included: ["Port Tax"],
    vessel_type: "Standard",
    supports_round_trip: false,
    one_way_available: true,
  },
  {
    id: "f5",
    origin_port: "HarbourFront Centre, Singapore",
    destination_port: "Nongsapura Ferry Terminal, Batam",
    operator: "Batam Fast Ferry",
    duration_minutes: 40,
    base_price_per_passenger: 38,
    image: "https://www.batamfast.com/Content/Images/vessel/aseanraider2-22072020b.jpg",
    description: "The fastest crossing to Nongsa, purpose-built for resort guests. Direct service with priority boarding and dedicated golf bag handling.",
    available_times: ["07:00", "09:00", "12:00", "15:00", "18:00"],
    return_available_times: ["08:00", "10:30", "13:30", "16:30", "19:30"],
    amenities: ["Air Conditioning", "Priority Boarding", "Golf Bag Handling", "Snack Bar", "USB Charging", "Wi-Fi"],
    fees_included: ["Terminal Fee", "Immigration Levy", "Port Tax", "Golf Bag Fee"],
    vessel_type: "High-Speed",
    supports_round_trip: true,
    one_way_available: true,
  },
  {
    id: "f6",
    origin_port: "HarbourFront Centre, Singapore",
    destination_port: "Batam Centre Ferry Terminal, Batam",
    operator: "Penguin Ferry",
    duration_minutes: 50,
    base_price_per_passenger: 35,
    image: "https://www.batamfast.com/Content/Images/vessel/aseanraider2-22072020b.jpg",
    description: "Penguin Ferry's premium service with spacious upper-deck seating and excellent punctuality record. Round-trip packages available at a discount.",
    available_times: ["07:30", "08:30", "10:00", "12:30", "14:30", "16:30", "18:30"],
    return_available_times: ["09:00", "10:00", "11:30", "14:00", "16:00", "18:00", "20:00"],
    amenities: ["Air Conditioning", "Upper Deck Seating", "Snack Bar", "Luggage Storage", "USB Charging", "Restroom"],
    fees_included: ["Terminal Fee", "Immigration Levy", "Port Tax"],
    vessel_type: "High-Speed",
    supports_round_trip: true,
    one_way_available: true,
  },
  {
    id: "f7",
    origin_port: "HarbourFront Centre, Singapore",
    destination_port: "Harbour Bay Ferry Terminal, Batam",
    operator: "Horizon Fast Ferry",
    duration_minutes: 45,
    base_price_per_passenger: 34,
    image: "https://horizonfastferry.com.sg/blog/wp-content/uploads/2024/01/111.jpg",
    description: "Horizon Fast Ferry's flagship HarbourFront–Harbour Bay service, offering direct access to Batam's city centre with frequent departures. Popular with golfers heading to Batam Hills, Southlinks, and Indah Puri courses.",
    available_times: ["07:00", "08:30", "10:00", "12:00", "14:00", "16:30", "18:30"],
    return_available_times: ["08:00", "09:30", "11:00", "13:00", "15:00", "17:30", "19:30"],
    amenities: ["Air Conditioning", "Snack Bar", "Life Jackets", "Luggage Storage", "USB Charging", "Wi-Fi"],
    fees_included: ["Terminal Fee", "Immigration Levy", "Port Tax"],
    vessel_type: "High-Speed",
    supports_round_trip: true,
    one_way_available: true,
  },
];